import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React from 'react';
import { Heading } from '@tesla/design-system-react';
import PropTypes from 'prop-types';
import IconBlacklisted from './IconBlacklisted.js';
import IconVIP from './IconVIP.js';

var FLAG_TITLE = {
  PRIORITY: 'Priority',
  BLOCKLISTED: 'Blocklisted'
};
var ICONS = _defineProperty(_defineProperty({}, FLAG_TITLE.PRIORITY, IconVIP), FLAG_TITLE.BLOCKLISTED, IconBlacklisted);
var TITLES = _defineProperty(_defineProperty({}, FLAG_TITLE.PRIORITY, 'business_priority_icon'), FLAG_TITLE.BLOCKLISTED, 'business_blocklisted_icon');
var FlagTitle = function FlagTitle(props) {
  var flagType = props.flagType;
  var Icon = ICONS[flagType];
  var title = TITLES[flagType];
  if (!Icon) {
    return flagType;
  }
  return /*#__PURE__*/React.createElement(Heading, {
    className: "tds--no_padding",
    is: "h6"
  }, /*#__PURE__*/React.createElement(Icon, {
    align: "text-middle",
    inline: true,
    title: title
  }), flagType);
};
FlagTitle.propTypes = {
  flagType: PropTypes.string.isRequired
};

export { FlagTitle as default };
